// extracted by mini-css-extract-plugin
export default {"container":"QrCode_container__HLFYW","qrCode":"QrCode_qrCode__xFSH+"};